import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useQRCode } from '@vueuse/integrations/useQRCode'
import { Icon } from '@iconify/vue2'
import { useClipboard } from '@vueuse/core'
import { ShareContentProvider } from '@/@web/modules/@shared/providers/ShareContent.provider'


export default /*#__PURE__*/_defineComponent({
  __name: 'TelegramLinkQrCode',
  props: {
    userId: null,
    reverse: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	userId: string
	reverse?: boolean
};



const telegramLink = computed(
	() => `${process.env.VUE_APP_TELEGRAM_BOT_LINK}?start=id-user-risco-incendio_${props.userId}`,
)

const { copy, copied } = useClipboard({ source: telegramLink })

const qr = useQRCode(telegramLink)

function shareToWhatsapp() {
	ShareContentProvider.shareToWhatsapp(telegramLink.value)
}

return { __sfc: true,props, telegramLink, copy, copied, qr, shareToWhatsapp, Icon }
}

})